import * as Y from 'yjs';
import findReferenceRegistryEntry from './findReferenceRegistryEntry';
import { SafeSpace } from '../types';

export default function isLiveBlockSourceArchived(space: SafeSpace, id: string) {
    const entry = findReferenceRegistryEntry(space, id) as Y.Map<unknown>;
    if (!entry) return false;
    return entry.get('isArchived') === true;
}
